//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceStatus } from './Enums';

export class CalendarEventSearchOptions extends ItemBase {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    StartTime: string | null = null;
    EndTime: string | null = null;
    EventIDs: string[] = [];
    EventCategoryIDs: string[] = [];
    EventLocationIDs: string[] = [];
    StudentIDs: string[] = [];
    TeacherIDs: string[] = [];
    OriginalTeacherIDs: string[] = [];
    SeriesIDs: string[] = [];
    AllDay: boolean | null = null;
    MakeUpCreditRequired: boolean | null = null;
    HoldTimeSlot: boolean | null = null;
    AttendanceStatuses: AttendanceStatus[] = [];
    MinDuration: number | null = null;
    MaxDuration: number | null = null;

    constructor(initializer?: Partial<CalendarEventSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarEventSearchOptions";
}
